import { QueryKey } from '@gogame/query';

const TEMPLATES = 'templates';

export const templatesQuery = new QueryKey(TEMPLATES);
